import { Ref, ref, computed } from "vue";
import { Flow, GroupWithPermissionForUser, MstSyouninGroup } from "@/types/SyouninGroup"
import { MstSyouninGroupsService } from "@/service/MstSyouninGroupsService";

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);

  // 承認グループform情報
  const form: Ref<MstSyouninGroup> = ref({});
  // form.userNameList = [];

  // 承認グループ登録で必要なオプション類を取得する
  const srv = new MstSyouninGroupsService();
  const groupsWithPermission: Ref<GroupWithPermissionForUser[]> = ref([])

  /** 自身が承認者のグループに対象ユーザーが所属するか（対象ユーザーに対する権限を持っているか）の情報を取得 */
  const hasPermissionForTargetUser = async (targetUserId: number) => {
    groupsWithPermission.value = await srv.hasPermissionForTargetUser(targetUserId)
  }

  // 指定グループの承認者か判定
  const canSyounin = ref(false);
  const isSyouninUser = async (groupId: number, userId?: number) => {
    canSyounin.value = await srv.isSyouninUser(groupId, userId)
    return canSyounin.value
  }

  // 指定グループの確認者か判定
  const canKakunin = ref(false);
  const isKakuninUser = async (groupId: number, userId?: number) => {
    canKakunin.value = await srv.isKakuninUser(groupId, userId)
    return canKakunin.value
  }

  const syouninFlow: Ref<Flow[]> = ref([])
  const getSyouninFlow = async (id: number, shinseiType: number, userId: number) => {
    loading.value++
    const res = await srv.getFlow(id, shinseiType, userId)
    syouninFlow.value = res
    loading.value--
    return syouninFlow.value
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  return {
    form,
    isLoading,
    isError,
    hasPermissionForTargetUser,
    isSyouninUser,
    canSyounin,
    isKakuninUser,
    canKakunin,
    groupsWithPermission,
    getSyouninFlow,
    syouninFlow
  }
}
